export default __webpack_public_path__ + "static/media/dtt-tool-large.5994e453.png";